module.exports = __webpack_public_path__ + "img/banner-02.4911d79d.png";